var map = {
	"./Countdown_0.png": 642,
	"./Countdown_1.png": 643,
	"./Countdown_2.png": 644,
	"./Countdown_3.png": 645,
	"./Countdown_4.png": 646,
	"./Countdown_5.png": 647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 641;